export const INIT_INDIVIDUI = 'INIT_INDIVIDUI';
export const INIT_INDIVIDUI_SELEZIONATI = 'INIT_INDIVIDUI_SELEZIONATI';

export const GET_INDIVIDUI_BY_OBJECTID_SUCCESS = 'GET_INDIVIDUI_BY_OBJECTID_SUCCESS';
export const GET_INDIVIDUI_BY_OBJECTID_FAIL = 'GET_INDIVIDUI_BY_OBJECTID_FAIL';

export const GET_DOCENTI_BY_OBJECTID_SUCCESS = 'GET_DOCENTI_BY_OBJECTID_SUCCESS';
export const GET_DOCENTI_BY_OBJECTID_FAIL = 'GET_DOCENTI_BY_OBJECTID_FAIL';
export const INIT_DOCENTI = 'INIT_DOCENTI';

export const SET_INDIVIDUI_SELEZIONATI = 'SET_INDIVIDUI_SELEZIONATI';

export const GET_INDIVIDUI = 'GET_INDIVIDUI';
export const GET_DOCENTI = 'GET_DOCENTI';

